import * as React from 'react';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import { deliverableItems, durationItems, functionalSkillsItems, placeItems, technicalSkillsItems } from 'src/config';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject } from 'src/model';
import { createProject  /*, sendActivationEmail */} from 'src/services';
import { DateInput } from '../../Input/DateInput';
import { LocationInput } from '../../Input/LocationInput';

interface IProjectModalProps {
  project: IProject;
  changeStep: (stepNumber: number) => void;
  handleChange: (e: React.ChangeEvent<Element>) => void;
  handleChangeMultiFunctionalSkills: (functionalSkills: any) =>void; 
  handleChangeMultiTechnicalSkills: (technicalSkills: any) =>void;
  handleChangeMultiplace: (place: any) =>void;
  handleChangeMultiDeliverable: (place: any) =>void;
  handleChangeMultiDuration: (place: any) =>void;
  handleDateChange: (date: Date) => void;
  handleLocationUpdate: (localisation: {
    label: string;
    location: { lat: number; lng: number };
  }) => void;
  toggleCreateProjectModal: () => void;
  toggleSignupConfirmationModal: () => void;
}

const CreateProjectThirdStep: React.SFC<
  IProjectModalProps & IGlobalContextProps
> = ({
  changeStep,
  context,
  handleChange,
  handleChangeMultiFunctionalSkills,
  handleChangeMultiTechnicalSkills,
  handleChangeMultiplace,
  handleChangeMultiDeliverable,
  handleChangeMultiDuration,
  handleDateChange,
  handleLocationUpdate,
  project,
  toggleCreateProjectModal,
  toggleSignupConfirmationModal,
}) => {
  const handleProject = async () => {
    const newProject = await createProject(project);
    if (newProject) {
      // sendActivationEmail();
      localStorage.removeItem('beadvize-IsCreating');

      context.toggleIsCreating();
      changeStep(1);
      toggleCreateProjectModal();
      toggleSignupConfirmationModal();
    }
  };

  const previousStep = () => {
    changeStep(2);
  };


  return (
    <Form className='p-5'>
      <FormGroup>
        <CreatableSelect
          name="functionalSkills"
          classNamePrefix="form-control"
          isMulti={true} 
          closeMenuOnSelect = {true}
          options={functionalSkillsItems}
          noOptionsMessage={() => 'Item non disponible'}
          placeholder='Compétences fonctionelles'    
          value={project.functionalSkills}
          onChange={handleChangeMultiFunctionalSkills}
          formatCreateLabel={value => `Ajouter  "${value}"`}
          createOptionPosition='first'
        />
      </FormGroup>
      <FormGroup>
      <CreatableSelect
        name="technicalSkills"
        classNamePrefix="form-control"
        isMulti={true} 
        closeMenuOnSelect = {true}
        options={technicalSkillsItems}
        noOptionsMessage={() => 'Item non disponible'}
        placeholder='Compétences techniques'    
        value={project.technicalSkills}
        onChange={handleChangeMultiTechnicalSkills}
        formatCreateLabel={value => `Ajouter  "${value}"`}
        createOptionPosition='first'
      />
      </FormGroup>
      <FormGroup>
      <CreatableSelect
          name="deliverable"
          classNamePrefix="form-control"
          isMulti={true} 
          closeMenuOnSelect = {true}
          options={deliverableItems}
          noOptionsMessage={() => 'Item non disponible'}
          placeholder='Livrables attendus'    
          value={project.deliverable}
          onChange={handleChangeMultiDeliverable}
          formatCreateLabel={value => `Ajouter  "${value}"`}
          createOptionPosition='first'
              />
        {/* <Input
          type='textarea'
          name='deliverable'
          placeholder='Livrables attendus'
         // value={project.deliverable}
          onChange={handleChange}
        /> */}
      </FormGroup>
      <Row className='d-flex justify-content-between'>
        <Col md='6' xs='auto'>
          <FormGroup>
            <Input
              type='text'
              name='budgetMin'
              placeholder='Budget min'
              value={project.budgetMin}
              onChange={handleChange}
              tag={NumberFormat}
              thousandSeparator={' '}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type='text'
              name='dailyPriceMin'
              placeholder='Tarif jour min'
              value={project.dailyPriceMin}
              onChange={handleChange}
              tag={NumberFormat}
              thousandSeparator={' '}
            />
          </FormGroup>
          <FormGroup>
            <DateInput
              placeholderText='Date de début'
              edit={true}
              name='startingDate'
              handleDateChange={handleDateChange}
              value={project.startingDate }
              minDate={new Date()}
              dateFormat='dd/MM/yyyy'
            />
          </FormGroup>
          <FormGroup>
          <Select
              name="duration"
              classNamePrefix="form-control"
              isMulti={false} 
              closeMenuOnSelect = {true}
              options={durationItems}
              placeholder='Durée  '    
              value={project.duration}
              onChange={handleChangeMultiDuration}
                  />
            {/* <Input
              type='number'
              name='duration'
              placeholder='Durée'
              // value={project.duration}
              onChange={handleChange}
            /> */}
          </FormGroup>
        </Col>
        <Col md='6' xs='auto'>
          <FormGroup>
            <Input
              type='text'
              name='budgetMax'
              placeholder='Budget max'
              value={project.budgetMax}
              onChange={handleChange}
              tag={NumberFormat}
              thousandSeparator={' '}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type='text'
              name='dailyPriceMax'
              placeholder='Tarif jour max'
              value={project.dailyPriceMax}
              onChange={handleChange}
              tag={NumberFormat}
              thousandSeparator={' '}
            />
          </FormGroup>
          <FormGroup>
            <LocationInput
              edit={true}
              localisation={project.localisation}
              handleLocationUpdate={handleLocationUpdate}
            />
          </FormGroup>
          <FormGroup>
            <Select
              name='place'
              classNamePrefix='form-control'
              isMulti={false} 
              closeMenuOnSelect = {true}
              options={placeItems}
              noOptionsMessage={() => 'Item non disponible'}
              placeholder='Forfait ou régie'    
              value={project.place}
              onChange={handleChangeMultiplace}
                  />
          </FormGroup>
        </Col>
      </Row>
      <Row className='d-flex justify-content-end'>
        <Col xs='4'>
          <Button
            className='text-uppercase text-white bg-dark border-0 mt-3'
            onClick={previousStep}
          >
            {'< Retour'}
          </Button>
        </Col>
        <Col xs='8' className='d-flex justify-content-around'>
          <Button
            className='text-uppercase text-white bg-success float-right border-0 mt-3'
            onClick={handleProject}
          >
            Finir plus tard
          </Button>
          <Button
            className='text-uppercase text-white bg-success float-right border-0 mt-3'
            onClick={handleProject}
          >
            Valider
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export const CreateProjectThirdStepwithGlobalContext = withGlobalContext(
  CreateProjectThirdStep
);


// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateProjectModal/CreateProjectThirdStep.tsx